import { render } from "./CreditWalletModal.vue?vue&type=template&id=5765069c"
import script from "./CreditWalletModal.vue?vue&type=script&lang=js"
export * from "./CreditWalletModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__